/**
 * EmptyDetailState · 文件夹既无照片又无子文件夹时的引导卡
 *
 * 只保留「手动添加照片」一个引导按钮
 */

import React from 'react'
import {
  FolderOpenOutlined,
  PlusOutlined,
  RightOutlined
} from '@ant-design/icons'
import styles from './Detail.module.scss'

interface EmptyDetailStateProps {
  onAddPhoto: () => void
}

const EmptyDetailState: React.FC<EmptyDetailStateProps> = ({ onAddPhoto }) => {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyIcon}>
        <FolderOpenOutlined />
      </div>
      <h2 className={styles.emptyTitle}>文件夹是空的</h2>
      <p className={styles.emptyDesc}>你可以手动添加照片到此文件夹</p>
      <div className={styles.emptyOptions}>
        <button
          type="button"
          className={styles.emptyOption}
          onClick={onAddPhoto}
        >
          <PlusOutlined />
          <span className={styles.emptyOptionLabel}>手动添加照片</span>
          <RightOutlined className={styles.emptyOptionArrow} />
        </button>
      </div>
    </div>
  )
}

export default EmptyDetailState
